module.exports = __webpack_public_path__ + "static/media/empty.d89d1cc4.svg";